import SystemConversionActionType from 'actions/systemConversion/systemConversionActionType';

const initialState = {
  systemConversions: [],
  systemConversionLogs: {},
};

const systemConversionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case SystemConversionActionType.SAVE_SYSTEM_CONVERSIONS:
    return {
      ...state,
      systemConversions: payload.data,
    };
  case SystemConversionActionType.RESET_SYSTEM_CONVERSIONS:
    return {
      ...state,
      systemConversions: [],
    };
  case SystemConversionActionType.SAVE_SYSTEM_CONVERSION_LOGS:
    return {
      ...state,
      systemConversionLogs: payload.data,
    };
  case SystemConversionActionType.RESET_SYSTEM_CONVERSION_LOGS:
    return {
      ...state,
      systemConversionLogs: {},
    };
  default:
    return state;
  }
};

export default systemConversionReducer;
